"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ssgIconsWeather = exports.iconSsgSunBottomFill = exports.ssgIconsSystem = exports.iconSsgFingerprintSearchLine = exports.iconSsgFingerprintSearchFill = exports.ssgIconsMap = exports.iconSsgLocationCrossLine = exports.iconSsgLocationCrossFill = exports.ssgIconsJustice = exports.iconSsgJusticeStickmanLine = exports.iconSsgJusticeStickmanFill = exports.iconSsgJusticePointLine = exports.iconSsgJusticePointFill = exports.iconSsgHandAvLine = exports.iconSsgHandAvFill = exports.iconSsgHandAjLine = exports.iconSsgHandAjFill = exports.iconSsgDocumentsBoxAvLine = exports.iconSsgDocumentsBoxAvFill = exports.iconSsgDocumentsBoxAjLine = exports.iconSsgDocumentsBoxAjFill = exports.iconSsgDeskAvLine = exports.iconSsgDeskAvFill = exports.iconSsgDeskAjLine = exports.iconSsgDeskAjFill = exports.ssgIconsEditor = exports.iconSsgRenameLine = exports.iconSsgRenameFill = exports.ssgIconsDocument = exports.iconSsgMergeLine = exports.iconSsgMergeFill = exports.ssgIconsBuilding = exports.iconSsgPenitentiaryLine = exports.iconSsgPenitentiaryFill = exports.ssgIconsArrow = exports.iconSsgArrowRotateRightLine = exports.iconSsgArrowRotateRightFill = exports.iconSsgArrowRotateLeftLine = exports.iconSsgArrowRotateLeftFill = void 0;
// This file is generated with a script
exports.iconSsgArrowRotateLeftFill = "fr-icon-ssg-arrow-rotate-left-fill";
exports.iconSsgArrowRotateLeftLine = "fr-icon-ssg-arrow-rotate-left-line";
exports.iconSsgArrowRotateRightFill = "fr-icon-ssg-arrow-rotate-right-fill";
exports.iconSsgArrowRotateRightLine = "fr-icon-ssg-arrow-rotate-right-line";
exports.ssgIconsArrow = [
    exports.iconSsgArrowRotateLeftFill,
    exports.iconSsgArrowRotateLeftLine,
    exports.iconSsgArrowRotateRightFill,
    exports.iconSsgArrowRotateRightLine,
];
exports.iconSsgPenitentiaryFill = "fr-icon-ssg-penitentiary-fill";
exports.iconSsgPenitentiaryLine = "fr-icon-ssg-penitentiary-line";
exports.ssgIconsBuilding = [
    exports.iconSsgPenitentiaryFill,
    exports.iconSsgPenitentiaryLine,
];
exports.iconSsgMergeFill = "fr-icon-ssg-merge-fill";
exports.iconSsgMergeLine = "fr-icon-ssg-merge-line";
exports.ssgIconsDocument = [
    exports.iconSsgMergeFill,
    exports.iconSsgMergeLine,
];
exports.iconSsgRenameFill = "fr-icon-ssg-rename-fill";
exports.iconSsgRenameLine = "fr-icon-ssg-rename-line";
exports.ssgIconsEditor = [
    exports.iconSsgRenameFill,
    exports.iconSsgRenameLine,
];
exports.iconSsgDeskAjFill = "fr-icon-ssg-desk-aj-fill";
exports.iconSsgDeskAjLine = "fr-icon-ssg-desk-aj-line";
exports.iconSsgDeskAvFill = "fr-icon-ssg-desk-av-fill";
exports.iconSsgDeskAvLine = "fr-icon-ssg-desk-av-line";
exports.iconSsgDocumentsBoxAjFill = "fr-icon-ssg-documents-box-aj-fill";
exports.iconSsgDocumentsBoxAjLine = "fr-icon-ssg-documents-box-aj-line";
exports.iconSsgDocumentsBoxAvFill = "fr-icon-ssg-documents-box-av-fill";
exports.iconSsgDocumentsBoxAvLine = "fr-icon-ssg-documents-box-av-line";
exports.iconSsgHandAjFill = "fr-icon-ssg-hand-aj-fill";
exports.iconSsgHandAjLine = "fr-icon-ssg-hand-aj-line";
exports.iconSsgHandAvFill = "fr-icon-ssg-hand-av-fill";
exports.iconSsgHandAvLine = "fr-icon-ssg-hand-av-line";
exports.iconSsgJusticePointFill = "fr-icon-ssg-justice-point-fill";
exports.iconSsgJusticePointLine = "fr-icon-ssg-justice-point-line";
exports.iconSsgJusticeStickmanFill = "fr-icon-ssg-justice-stickman-fill";
exports.iconSsgJusticeStickmanLine = "fr-icon-ssg-justice-stickman-line";
exports.ssgIconsJustice = [
    exports.iconSsgDeskAjFill,
    exports.iconSsgDeskAjLine,
    exports.iconSsgDeskAvFill,
    exports.iconSsgDeskAvLine,
    exports.iconSsgDocumentsBoxAjFill,
    exports.iconSsgDocumentsBoxAjLine,
    exports.iconSsgDocumentsBoxAvFill,
    exports.iconSsgDocumentsBoxAvLine,
    exports.iconSsgHandAjFill,
    exports.iconSsgHandAjLine,
    exports.iconSsgHandAvFill,
    exports.iconSsgHandAvLine,
    exports.iconSsgJusticePointFill,
    exports.iconSsgJusticePointLine,
    exports.iconSsgJusticeStickmanFill,
    exports.iconSsgJusticeStickmanLine,
];
exports.iconSsgLocationCrossFill = "fr-icon-ssg-location-cross-fill";
exports.iconSsgLocationCrossLine = "fr-icon-ssg-location-cross-line";
exports.ssgIconsMap = [
    exports.iconSsgLocationCrossFill,
    exports.iconSsgLocationCrossLine,
];
exports.iconSsgFingerprintSearchFill = "fr-icon-ssg-fingerprint-search-fill";
exports.iconSsgFingerprintSearchLine = "fr-icon-ssg-fingerprint-search-line";
exports.ssgIconsSystem = [
    exports.iconSsgFingerprintSearchFill,
    exports.iconSsgFingerprintSearchLine,
];
exports.iconSsgSunBottomFill = "fr-icon-ssg-sun-bottom-fill";
exports.ssgIconsWeather = [
    exports.iconSsgSunBottomFill,
];
